"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.adminSecretListConstants = void 0;
var adminSecretListConstants = {
  alertText: 'alert',
  height: 295
};
exports.adminSecretListConstants = adminSecretListConstants;
var classes = {
  fieldSpacing: 'waiting-approval-widget-field-spacing'
};
exports.classes = classes;